import React, { useEffect } from "react";

function useListenKey<T extends HTMLElement,>(
  ref: React.RefObject<T> | null,
  handler: (event: any) => void | (() => void) | null,
  key: string,
  {
    listenChild = false,
    global = true
  } = {}) {
  useEffect(() => {
    if (!handler) return;
    const listener = (event: KeyboardEvent) => {
      if (ref !== null &&  (listenChild ? (!ref?.current?.contains(document.activeElement)) : (ref?.current !== document.activeElement))) {
        return;
      }
      if (event.key === key) {
        handler(event)
      }
    };
    const target = (global || ref === null) ? document : (ref.current)
    target?.addEventListener("keydown", listener as EventListener);
    return () => {
      target?.removeEventListener("keydown", listener as EventListener);
    };
  }, [ref, handler, key]);
}

export { useListenKey }
